import React, { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { IoIosWarning } from "react-icons/io";

const MissingCCNAlert = ({ missingFacilities, isSpecificFacility, resetKey }) => {
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        setDismissed(false);
    }, [resetKey]);

    if (dismissed) return null;

    let content;
    if (isSpecificFacility) {
        content = (
            <>
                <span className="font-bold">Missing CCN: </span>
                There is no CCN in our records for this facility, resulting in incomplete data on this page.
            </>
        );
    } else {
        if (!missingFacilities || missingFacilities.length === 0) return null;
        content = (
            <>
                <span className="font-bold">
                    Missing CCN ({missingFacilities.length} {missingFacilities.length === 1 ? "facility" : "facilities"}):
                </span>{" "}
                {missingFacilities.join(", ")}
            </>
        );
    }

    return (
        <div className="flex w-full items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-2 dark:border-red-700 dark:bg-navy-700">
            <IoIosWarning className="h-5 w-5 flex-shrink-0 text-red-600 dark:text-red-400" />
            <div className="flex-1 truncate text-sm text-red-800 dark:text-white" title={!isSpecificFacility && missingFacilities ? missingFacilities.join(", ") : undefined}>
                {content}
            </div>
            <button
                onClick={() => setDismissed(true)}
                className="flex-shrink-0 rounded p-1 text-red-700 hover:bg-red-100 dark:text-white dark:hover:bg-navy-600"
                aria-label="Dismiss alert"
            >
                <IoMdClose className="h-4 w-4" />
            </button>
        </div>
    );
};

export default MissingCCNAlert;
